import { useQuery } from "@tanstack/react-query";

import { useSession } from "./hooks";
import { fetchMe, type MeResponse } from "./meApi";

export function useMe() {
  const { user } = useSession();
  return useQuery<MeResponse>({
    queryKey: ["me"],
    queryFn: fetchMe,
    enabled: !!user,
    staleTime: 5 * 60_000,
  });
}
